import React from "react";

import { Icon } from "../../../../Icon";
import { ButtonCell } from "../../../ButtonCell";
import { createDisplayNameForButtonCellSchevronElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellSchevronElement } from "../../utils/getTestId";

import classes from "../../ButtonCellSchevron.styl";

const BUTTON_CELL_SCHEVRON_RIGHT_ADDON_TEST_ID =
    createTestIdForButtonCellSchevronElement("right-addon");

const RIGHT_ICON_TEST_ID =
    createTestIdForButtonCellSchevronElement("right-icon");

export const ButtonCellSchevronRightAddon = () => {
    return (
        <ButtonCell.RightAddon
            data-uikit={BUTTON_CELL_SCHEVRON_RIGHT_ADDON_TEST_ID}
        >
            <Icon
                size="24"
                data-tsid={RIGHT_ICON_TEST_ID}
                className={classes.icon}
                icon="glyph_right_24+"
                aria-hidden="true"
            />
        </ButtonCell.RightAddon>
    );
};

ButtonCellSchevronRightAddon.displayName =
    createDisplayNameForButtonCellSchevronElement("RightAddon");

export default ButtonCellSchevronRightAddon;
